import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/guide', '/sign', '/auth-redirect', '/bind', '/register']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/guide') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (!store.getters.userInfo.type && store.getters.userInfo.type !== 0) {
        store.dispatch('GetInfo').then(res => {
          const role = res.result.type
          store
            .dispatch('GenerateRoutes', role)
            .then(accessRoutes => {
              router.addRoutes(accessRoutes)
              next({ ...to, replace: true })
            })
            .catch(() => {
              store.dispatch('FedLogOut').then(() => {
                next({ path: '/' })
              })
            })
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/sign?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
